<template>
  <div class="mt-4">
    <div class="ibox">
      <div class="ibox-title">
        Histórico de consultas deste protocolo
      </div>

      <ChronotachographHistories v-if="showChronotachographHistories" :chronotachograph="chronotachograph"/>
    </div>
  </div>
</template>

<script>
  import ModelMapper from '@/mixins/ModelMapper'
  import ChronotachographHistories from '@/components/cm-crono/ChronotachographHistories'
  import { mapMutations } from 'vuex'

  export default {
    components: { ChronotachographHistories },
    computed: {
      chronotachograph() {
        return this.getModel
      },
    },
    created() {
      this.asyncTemplateShow(this.id, {
        after: ({model}) => {
          this.setNameBreadcrumb(model.protocol)
          this.showChronotachographHistories = true
        },
      })
    },
    data: () => ({
      modelPathPrefix: 'maestro',
      nameModel: 'Chronotachograph',
      showChronotachographHistories: false,
    }),
    methods: {
      ...mapMutations(['setNameBreadcrumb']),
    },
    mixins: [ModelMapper],
    name: 'Show',
    props: {
      id: { required: false }
    }
  }
</script>

<style scoped>

</style>
